import { inject, observer } from "mobx-react";
import { MariDataStore } from "../../../store/store";
import { useTranslation } from "react-i18next";
import { TextFieldInput } from "../../../../../components/form-inputs";

export interface BaseAddressInputProps {
  mariDataStore?: MariDataStore;
}

const InputStringMaximumLength = 99;

function LocationNameInput(props: BaseAddressInputProps) {
  const mariDataStore = props.mariDataStore!;
  const { t } = useTranslation("mari-grid");
  const baseAddress = mariDataStore.selectedMari.baseAddress;
  const { errorMessages } = mariDataStore;

  let errorMessageText = "";
  let helperText = null;

  if (errorMessages) {
    if (errorMessages["baseAddress"]) {
      errorMessageText = t("RequiredInformation");
    } else if (errorMessages["username"]) {
      helperText = " ";
    }
  }

  return (
    <TextFieldInput
      value={baseAddress}
      disabled={mariDataStore.isValidationInProgress}
      mandatory
      errorMessage={errorMessageText}
      helperMessage={helperText}
      label={t("BaseAddress").toUpperCase()}
      placeholder={t("BaseAddress")}
      onChange={(event: any) => {
        const baseAddress = event.target.value;
        if (baseAddress.length > InputStringMaximumLength) return;

        mariDataStore.setSelectedMareBaseAdress(baseAddress);
        mariDataStore.setValidated(false);
      }}
      onValueChangeDebounced={() => {
        mariDataStore.validateSelectedMari("baseAddress");
        mariDataStore.setValidated(true);
      }}
    />
  );
}

export default inject("mariDataStore")(observer(LocationNameInput));
